import { Routes } from '@angular/router';

export const exchangeRoutes: Routes = [
  {
    path: 'ads/binance-fix-api',
    loadComponent: () => import('./binance-fix-api/binance-fix-api.component').then((m) => m.BinanceFixApiComponent),
    data: {
      sitemap: {
        loc: 'ads/binance-fix-api',
        lastmod: '2025-02-07',
      },
      meta: {
        loc: 'ads/binance-fix-api',
        fileName: '/ads/binance-fix-api',
        title: 'Binance FIX API | Axon Trade',
        description:
          'FIX API for Binance and Binance US crypto exchange. Use Axon Trade OEMS to trade on Binance and Binance US and 30+ other crypto exchanges using FIX 4.4 API.',
        keywords:
          'binance fix api,binance us fix api,binance professional api,binance trading,binance oems,binance hft,binance high frequency trading',
        imgUrl: '/assets/twitter-card/axon-trade-binance-fix-api-page-twitter-card.jpg',
        og_type: 'article',
      },
    },
  },
  {
    path: 'bitmart-fix-api',
    loadComponent: () => import('./bitmart-fix-api/bitmart-fix-api.component').then((m) => m.BitMartFixApiComponent),
    data: {
      sitemap: {
        loc: 'bitmart-fix-api',
        lastmod: '2025-02-07',
      },
      meta: {
        loc: 'bitmart-fix-api',
        fileName: '/bitmart-fix-api',
        title: 'BitMart FIX API | Axon Trade',
        description:
          'FIX API for BitMart crypto exchange. Use Axon Trade OEMS to trade on BitMart and 30+ other crypto exchanges using FIX 4.4 API.',
        keywords:
          'bitmart fix api,bitmart professional api,bitmart trading,bitmart oems,bitmart hft,bitmart high frequency trading',
        imgUrl: '/assets/twitter-card/axon-trade-bitmart-fix-api-page-twitter-card.png',
        og_type: 'article',
      },
    },
  },
  {
    path: 'kucoin-fix-api',
    loadComponent: () => import('./kucoin-fix-api/kucoin-fix-api.component').then((m) => m.KucoinFixApiComponent),
    data: {
      sitemap: {
        loc: 'kucoin-fix-api',
        lastmod: '2024-11-06',
      },
      meta: {
        loc: 'kucoin-fix-api',
        fileName: '/kucoin-fix-api',
        title: 'Kucoin FIX API | Axon Trade',
        description:
          'FIX API for Kucoin crypto exchange. Use Axon Trade OEMS to trade on Kucoin and 30+ other crypto exchanges using FIX 4.4 API.',
        keywords:
          'kucoin fix api,kucoin professional api,kucoin trading,kucoin oems,kucoin hft,kucoin high frequency trading',
        imgUrl: '/assets/twitter-card/axon-trade-kucoin-fix-api-page-twitter-card.png',
        og_type: 'article',
      },
    },
  },
  {
    path: 'coinbase-fix-api',
    loadComponent: () => import('./coinbase-fix-api/coinbase-fix-api.component').then((m) => m.CoinbaseFixApiComponent),
    data: {
      sitemap: {
        loc: 'coinbase-fix-api',
        lastmod: '2024-11-06',
      },
      meta: {
        loc: 'coinbase-fix-api',
        fileName: '/coinbase-fix-api',
        title: 'Coinbase FIX API | Axon Trade',
        description:
          'FIX API for Coinbase crypto exchange. Use Axon Trade OEMS to trade on Coinbase and 30+ other crypto exchanges using FIX 4.4 API.',
        keywords:
          'coinbase fix api,coinbase professional api,coinbase trading,coinbase oems,coinbase hft,coinbase high frequency trading',
        imgUrl: '/assets/twitter-card/axon-trade-coinbase-fix-api-page-twitter-card.png',
        og_type: 'article',
      },
    },
  },
  {
    path: 'htx-fix-api',
    loadComponent: () => import('./htx-fix-api/htx-fix-api.component').then((m) => m.HtxFixApiComponent),
    data: {
      sitemap: {
        loc: 'htx-fix-api',
        lastmod: '2024-11-06',
      },
      meta: {
        loc: 'htx-fix-api',
        fileName: '/htx-fix-api',
        title: 'HTX FIX API | Axon Trade',
        description:
          'FIX API for HTX crypto exchange. Use Axon Trade OEMS to trade on HTX and 30+ other crypto exchanges using FIX 4.4 API.',
        keywords: 'htx fix api,htx professional api,htx trading,htx oems,htx hft,htx high frequency trading',
        imgUrl: '/assets/twitter-card/axon-trade-htx-fix-api-page-twitter-card.png',
        og_type: 'article',
      },
    },
  },
  {
    path: 'kraken-fix-api',
    loadComponent: () => import('./kraken-fix-api/kraken-fix-api.component').then((m) => m.KrakenFixApiComponent),
    data: {
      sitemap: {
        loc: 'kraken-fix-api',
        lastmod: '2024-11-06',
      },
      meta: {
        loc: 'kraken-fix-api',
        fileName: '/kraken-fix-api',
        title: 'Kraken FIX API | Axon Trade',
        description:
          'FIX API for Kraken crypto exchange. Use Axon Trade OEMS to trade on Kraken and 30+ other crypto exchanges using FIX 4.4 API.',
        keywords:
          'kraken fix api,kraken professional api,kraken trading,kraken oems,kraken hft,kraken high frequency trading',
        imgUrl: '/assets/twitter-card/axon-trade-kraken-fix-api-page-twitter-card.png',
        og_type: 'article',
      },
    },
  },
  {
    path: 'bitstamp-fix-api',
    loadComponent: () => import('./bitstamp-fix-api/bitstamp-fix-api.component').then((m) => m.BitstampFixApiComponent),
    data: {
      sitemap: {
        loc: 'bitstamp-fix-api',
        lastmod: '2024-11-06',
      },
      meta: {
        loc: 'bitstamp-fix-api',
        fileName: '/bitstamp-fix-api',
        title: 'Bitstamp FIX API | Axon Trade',
        description:
          'FIX API for Bitstamp crypto exchange. Use Axon Trade OEMS to trade on Bitstamp and 30+ other crypto exchanges using FIX 4.4 API.',
        keywords:
          'bitstamp fix api,bitstamp professional api,bitstamp trading,bitstamp oems,bitstamp hft,bitstamp high frequency trading',
        imgUrl: '/assets/twitter-card/axon-trade-bitstamp-fix-api-page-twitter-card.png',
        og_type: 'article',
      },
    },
  },
  {
    path: 'gemini-fix-api',
    loadComponent: () => import('./gemini-fix-api/gemini-fix-api.component').then((m) => m.GeminiFixApiComponent),
    data: {
      sitemap: {
        loc: 'gemini-fix-api',
        lastmod: '2024-11-06',
      },
      meta: {
        loc: 'gemini-fix-api',
        fileName: '/gemini-fix-api',
        title: 'Gemini FIX API | Axon Trade',
        description:
          'FIX API for Gemini crypto exchange. Use Axon Trade OEMS to trade on Gemini and 30+ other crypto exchanges using FIX 4.4 API.',
        keywords:
          'gemini fix api,gemini professional api,gemini trading,gemini oems,gemini hft,gemini high frequency trading',
        imgUrl: '/assets/twitter-card/axon-trade-gemini-fix-api-page-twitter-card.png',
        og_type: 'article',
      },
    },
  },
  {
    path: 'okx-fix-api',
    loadComponent: () => import('./okx-fix-api/okx-fix-api.component').then((m) => m.OkxFixApiComponent),
    data: {
      sitemap: {
        loc: 'okx-fix-api',
        lastmod: '2025-09-23',
      },
      meta: {
        loc: 'okx-fix-api',
        fileName: '/okx-fix-api',
        title: 'OKX FIX API | Axon Trade',
        description:
          'FIX API for OKX crypto exchange. Use Axon Trade OEMS to trade on OKX and 30+ other crypto exchanges using FIX 4.4 API.',
        keywords: 'okx fix api,okx professional api,okx trading,okx oems,okx hft,okx high frequency trading',
        imgUrl: '/assets/twitter-card/axon-trade-okx-fix-api-page-twitter-card.png',
        og_type: 'article',
      },
    },
  },
  {
    path: 'hitbtc-fix-api',
    loadComponent: () => import('./hitbtc-fix-api/hitbtc-fix-api.component').then((m) => m.HitbtcFixApiComponent),
    data: {
      sitemap: {
        loc: 'hitbtc-fix-api',
        lastmod: '2024-11-06',
      },
      meta: {
        loc: 'hitbtc-fix-api',
        fileName: '/hitbtc-fix-api',
        title: 'HitBTC FIX API | Axon Trade',
        description:
          'FIX API for HitBTC crypto exchange. Use Axon Trade OEMS to trade on HitBTC and 30+ other crypto exchanges using FIX 4.4 API.',
        keywords:
          'hitbtc fix api,hitbtc professional api,hitbtc trading,hitbtc oems,hitbtc hft,hitbtc high frequency trading',
        imgUrl: '/assets/twitter-card/axon-trade-hitbtc-fix-api-page-twitter-card.png',
        og_type: 'article',
      },
    },
  },
  {
    path: 'cexio-fix-api',
    loadComponent: () => import('./cexio-fix-api/cexio-fix-api.component').then((m) => m.CexioFixApiComponent),
    data: {
      sitemap: {
        loc: 'cexio-fix-api',
        lastmod: '2024-11-06',
      },
      meta: {
        loc: 'cexio-fix-api',
        fileName: '/cexio-fix-api',
        title: 'CEX.IO FIX API | Axon Trade',
        description:
          'FIX API for CEX.IO crypto exchange. Use Axon Trade OEMS to trade on CEX.IO and 30+ other crypto exchanges using FIX 4.4 API.',
        keywords:
          'cex.io fix api,cex.io professional api,cex.io trading,cex.io oems,cex.io hft,cex.io high frequency trading',
        imgUrl: '/assets/twitter-card/axon-trade-cexio-fix-api-page-twitter-card.png',
        og_type: 'article',
      },
    },
  },
  {
    path: 'bybit-fix-api',
    loadComponent: () => import('./bybit-fix-api/bybit-fix-api.component').then((m) => m.BybitFixApiComponent),
    data: {
      sitemap: {
        loc: 'bybit-fix-api',
        lastmod: '2025-09-23',
      },
      meta: {
        loc: 'bybit-fix-api',
        fileName: '/bybit-fix-api',
        title: 'Bybit FIX API | Axon Trade',
        description:
          'FIX API for Bybit crypto exchange. Use Axon Trade OEMS to trade on Bybit and 30+ other crypto exchanges using FIX 4.4 API.',
        keywords:
          'bybit fix api,bybit professional api,bybit trading,bybit oems,bybit hft,bybit high frequency trading,crypto,crypto trading,bybit,fix api',
        imgUrl: '/assets/twitter-card/axon-trade-bybit-fix-api-page-twitter-card.png',
        og_type: 'article',
      },
    },
  },
  {
    path: 'bitfinex-fix-api',
    loadComponent: () => import('./bitfinex-fix-api/bitfinex-fix-api.component').then((m) => m.BitfinexFixApiComponent),
    data: {
      sitemap: {
        loc: 'bitfinex-fix-api',
        lastmod: '2024-11-06',
      },
      meta: {
        loc: 'bitfinex-fix-api',
        fileName: '/bitfinex-fix-api',
        title: 'Bitfinex FIX API | Axon Trade',
        description:
          'FIX API for Bitfinex crypto exchange. Use Axon Trade OEMS to trade on Bitfinex and 30+ other crypto exchanges using FIX 4.4 API.',
        keywords:
          'bitfinex fix api,bitfinex professional api,bitfinex trading,bitfinex oems,bitfinex hft,bitfinex high frequency trading',
        imgUrl: '/assets/twitter-card/axon-trade-bitfinex-fix-api-page-twitter-card.png',
        og_type: 'article',
      },
    },
  },
  {
    path: 'bithumb-fix-api',
    loadComponent: () => import('./bithumb-fix-api/bithumb-fix-api.component').then((m) => m.BithumbFixApiComponent),
    data: {
      sitemap: {
        loc: 'bithumb-fix-api',
        lastmod: '2024-11-06',
      },
      meta: {
        loc: 'bithumb-fix-api',
        fileName: '/bithumb-fix-api',
        title: 'Bithumb FIX API | Axon Trade',
        description:
          'FIX API for Bithumb crypto exchange. Use Axon Trade OEMS to trade on Bithumb and 30+ other crypto exchanges using FIX 4.4 API.',
        keywords:
          'bithumb fix api,bithumb professional api,bithumb trading,bithumb oems,bithumb hft,bithumb high frequency trading',
        imgUrl: '/assets/twitter-card/axon-trade-bithumb-fix-api-page-twitter-card.png',
        og_type: 'article',
      },
    },
  },
  {
    path: 'gateio-fix-api',
    loadComponent: () => import('./gateio-fix-api/gateio-fix-api.component').then((m) => m.GateioFixApiComponent),
    data: {
      sitemap: {
        loc: 'gateio-fix-api',
        lastmod: '2024-11-06',
      },
      meta: {
        loc: 'gateio-fix-api',
        fileName: '/gateio-fix-api',
        title: 'Gate.io FIX API | Axon Trade',
        description:
          'FIX API for Gate.io crypto exchange. Use Axon Trade OEMS to trade on Gate.io and 30+ other crypto exchanges using FIX 4.4 API.',
        keywords:
          'gate.io fix api,gate.io professional api,gate.io trading,gate.io oems,gate.io hft,gate.io high frequency trading',
        imgUrl: '/assets/twitter-card/axon-trade-gateio-fix-api-page-twitter-card.png',
        og_type: 'article',
      },
    },
  },
  {
    path: 'deribit-fix-api',
    loadComponent: () => import('./deribit-fix-api/deribit-fix-api.component').then((m) => m.DeribitFixApiComponent),
    data: {
      sitemap: {
        loc: 'deribit-fix-api',
        lastmod: '2024-11-06',
      },
      meta: {
        loc: 'deribit-fix-api',
        fileName: '/deribit-fix-api',
        title: 'Deribit FIX API | Axon Trade',
        description:
          'FIX API for Deribit crypto exchange. Use Axon Trade OEMS to trade on Deribit and 30+ other crypto exchanges using FIX 4.4 API.',
        keywords:
          'deribit fix api,deribit professional api,deribit trading,deribit oems,deribit hft,deribit high frequency trading',
        imgUrl: '/assets/twitter-card/axon-trade-deribit-fix-api-page-twitter-card.png',
        og_type: 'article',
      },
    },
  },
  {
    path: 'exmo-fix-api',
    loadComponent: () => import('./exmo-fix-api/exmo-fix-api.component').then((m) => m.ExmoFixApiComponent),
    data: {
      sitemap: {
        loc: 'exmo-fix-api',
        lastmod: '2024-11-06',
      },
      meta: {
        loc: 'exmo-fix-api',
        fileName: '/exmo-fix-api',
        title: 'EXMO FIX API | Axon Trade',
        description:
          'FIX API for EXMO crypto exchange. Use Axon Trade OEMS to trade on EXMO and 30+ other crypto exchanges using FIX 4.4 API.',
        keywords: 'exmo fix api,exmo professional api,exmo trading,exmo oems,exmo hft,exmo high frequency trading',
        imgUrl: '/assets/twitter-card/axon-trade-exmo-fix-api-page-twitter-card.png',
        og_type: 'article',
      },
    },
  },
  {
    path: 'bitflyer-fix-api',
    loadComponent: () => import('./bitflyer-fix-api/bitflyer-fix-api.component').then((m) => m.BitflyerFixApiComponent),
    data: {
      sitemap: {
        loc: 'bitflyer-fix-api',
        lastmod: '2024-11-06',
      },
      meta: {
        loc: 'bitflyer-fix-api',
        fileName: '/bitflyer-fix-api',
        title: 'BitFlyer FIX API | Axon Trade',
        description:
          'FIX API for BitFlyer crypto exchange. Use Axon Trade OEMS to trade on BitFlyer and 30+ other crypto exchanges using FIX 4.4 API.',
        keywords:
          'bitfyer fix api,bitfyer professional api,bitfyer trading,bitfyer oems,bitfyer hft,bitfyer high frequency trading',
        imgUrl: '/assets/twitter-card/axon-trade-bitflyer-fix-api-page-twitter-card.png',
        og_type: 'article',
      },
    },
  },
  {
    path: 'amber-fix-api',
    loadComponent: () => import('./amber-fix-api/amber-fix-api.component').then((m) => m.AmberFixApiComponent),
    data: {
      sitemap: {
        loc: 'amber-fix-api',
        lastmod: '2024-11-06',
      },
      meta: {
        loc: 'amber-fix-api',
        fileName: '/amber-fix-api',
        title: 'Amber FIX API | Axon Trade',
        description:
          'FIX API for Amber crypto exchange. Use Axon Trade OEMS to trade on Amber and 30+ other crypto exchanges using FIX 4.4 API.',
        keywords:
          'amber fix api,amber professional api,amber trading,amber oems,amber hft,amber high frequency trading',
        imgUrl: '/assets/twitter-card/axon-trade-amber-fix-api-page-twitter-card.png',
        og_type: 'article',
      },
    },
  },
  {
    path: 'whitebit-fix-api',
    loadComponent: () => import('./whitebit-fix-api/whitebit-fix-api.component').then((m) => m.WhitebitFixApiComponent),
    data: {
      sitemap: {
        loc: 'whitebit-fix-api',
        lastmod: '2024-11-06',
      },
      meta: {
        loc: 'whitebit-fix-api',
        fileName: '/whitebit-fix-api',
        title: 'WhiteBIT FIX API | Axon Trade',
        description:
          'FIX API for WhiteBIT crypto exchange. Use Axon Trade OEMS to trade on WhiteBIT and 30+ other crypto exchanges using FIX 4.4 API.',
        keywords:
          'whitebit fix api,whitebit professional api,whitebit trading,whitebit oems,whitebit hft,whitebit high frequency trading',
        imgUrl: '/assets/twitter-card/axon-trade-whitebit-fix-api-page-twitter-card.png',
        og_type: 'article',
      },
    },
  },
  {
    path: 'bitget-fix-api',
    loadComponent: () => import('./bitget-fix-api/bitget-fix-api.component').then((m) => m.BitgetFixApiComponent),
    data: {
      sitemap: {
        loc: 'bitget-fix-api',
        lastmod: '2024-11-06',
      },
      meta: {
        loc: 'bitget-fix-api',
        fileName: '/bitget-fix-api',
        title: 'Bitget FIX API | Axon Trade',
        description:
          'FIX API for Bitget crypto exchange. Use Axon Trade OEMS to trade on Bitget and 30+ other crypto exchanges using FIX 4.4 API.',
        keywords:
          'bitget fix api,bitget professional api,bitget trading,bitget oems,bitget hft,bitget high frequency trading',
        imgUrl: '/assets/twitter-card/axon-trade-bitget-fix-api-page-twitter-card.png',
        og_type: 'article',
      },
    },
  },
  {
    path: 'rulematch-fix-api',
    loadComponent: () =>
      import('./rulematch-fix-api/rulematch-fix-api.component').then((m) => m.RulematchFixApiComponent),
    data: {
      sitemap: {
        loc: 'rulematch-fix-api',
        lastmod: '2024-11-06',
      },
      meta: {
        loc: 'rulematch-fix-api',
        fileName: '/rulematch-fix-api',
        title: 'Rulematch FIX API | Axon Trade',
        description:
          'FIX API for Rulematch crypto exchange. Use Axon Trade OEMS to trade on Rulematch and 30+ other crypto exchanges using FIX 4.4 API.',
        keywords:
          'rulematch fix api,rulematch professional api,rulematch trading,rulematch oems,rulematch hft,rulematch high frequency trading',
        imgUrl: '/assets/twitter-card/axon-trade-rulematch-fix-api-page-twitter-card.png',
        og_type: 'article',
      },
    },
  },
];
